import React, { useState, useEffect, useRef } from 'react';
import searchIconSolid from '../../images/icons/searchIconSolid.svg';
import './AssignBP.css';
import searchDelete from '../../images/icons/searchDelete.svg';
import lodash from 'lodash';
import { AssignRmToBP } from '../../common/constants/api';

function AssignRmModalField(props) {
  const [rmList, setRMList] = useState([]);
  const [rmFilteredList, setRmFilteredList] = useState([]);
  const [searchIcon, setSearchIcon] = useState(true);
  const [DeleteIcon, setDeleteIcon] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(false);
  const [selectedRm, setRmSelected] = useState('');

  const serachRm = useRef('');
  const listView = useRef('');

  useEffect(() => {
    setRMList(props.rmList);
    setRmFilteredList(props.rmList);
  }, [props.rmList]);

  function FilterRmList() {
    let value = serachRm.current.value;
    const FilteredList = rmList.filter(item =>
      item.fullName
        .toString()
        .toLowerCase()
        .includes(value.toString().toLowerCase())
    );
    setRmFilteredList(FilteredList);
  }
  return (
    <div className="w-full block">
      <p className="text-base text-black-0 text-left font-roboto font-normal ">
        {props?.bpName}
      </p>
      <p className="text-sm text-grey-995 text-left font-roboto font-normal py-1 ">
        {props?.bpCode ? props.bpCode : '-'}
      </p>
      <hr className="text-grey-999 my-2" />
      {props.currRm ? (
        <div className="w-full bg-grey-1004 block py-1 text-left px-3 mt-4">
          <p className="font-roboto  text-black-500 py-4 text-base font-norml">
            Current RM
          </p>
          <p className="font-roboto  text-green-600 pb-4 text-base font-norml">
            {props.currRm}
          </p>
        </div>
      ) : null}
      <p className="text-lg text-black-500 text-left font-roboto font-normal pt-7">
        Assign RM
      </p>
      <div className="w-11/12 mx-auto flex shadow-2xl  px-4 mt-5   items-center rounded border-2 border-blue-900">
        {searchIcon ? (
          <div>
            <img
              src={searchIconSolid}
              alt="search rm "
              className="w-4 mr-auto "
            />
          </div>
        ) : null}
        <input
          className="w-10/12 placeholder-grey-1001 ml-3 text-sm font-roboto font-normal h-10"
          placeholder="Search RM"
          ref={serachRm}
          onFocus={() => {
            listView.current.style.visibility = 'visible';
          }}
          onChange={lodash.debounce(function() {
            FilterRmList();
          }, 200)}
          disabled={!searchIcon}
        />
        {DeleteIcon ? (
          <div>
            <img
              src={searchDelete}
              className="w-4 ml-auto cursor-pointer "
              alt="delete"
              onClick={() => {
                serachRm.current.value = '';
                listView.current.style.visibility = 'visible';
                setSearchIcon(true),
                  setDeleteIcon(false),
                  (serachRm.current.style.color = '#48545E');
                setRmFilteredList(rmList);
              }}
            />
          </div>
        ) : null}
      </div>
      <div
        className="block w-11/12  mx-auto relative mb-10  h-34 overflow-auto "
        style={{ height: '120px' }}
      >
        <div
          className="text-left font-roboto font-normal text-sm text-black-500 px-2 cursor-pointer my-2 "
          ref={listView}
        >
          {rmFilteredList.map(eachRm => {
            return (
              <div
                className="py-3 w-full"
                onClick={() => {
                  serachRm.current.value = eachRm.fullName;
                  serachRm.current.style.color = '#00ACB8';
                  listView.current.style.visibility = 'hidden';
                  setSearchIcon(false);
                  setDeleteIcon(true);
                  setRmSelected(eachRm.userId);
                }}
              >
                {eachRm.fullName}
              </div>
            );
          })}
        </div>
      </div>

      <div className="w-full flex ">
        <button
          className="w-24 px-3 py-3 bg-grey-1002 text-grey-1003 font-roboto font-normal rounded ml-auto  "
          onClick={() => {
            props.setShow(false);
          }}
        >
          Cancel
        </button>
        <button
          type="button"
          className={
            searchIcon || submitting
              ? 'w-24 px-3 py-3 bg-grey-1002 text-grey-1003 font-roboto font-normal rounded mx-3 bg-grey-1002 text-white font-bold py-2 px-4 rounded  cursor-not-allowed'
              : 'w-24 px-3 py-3 bg-green-600 text-white font-roboto font-normal rounded mx-3 bg-grey-1002 text-white font-bold py-2 px-4 rounded'
          }
          onClick={async () => {
            setSubmitting(true);
            AssignRmToBP(parseInt(selectedRm), parseInt(props.row.id))
              .then(res => {
                props.setShow(false);
                setSubmitting(false);
                typeof props?.successUrl == 'function' && props?.successUrl();
              })
              .catch(err => {
                err.response
                  ? err.response.data
                    ? setError(err.response.data.message)
                    : null
                  : setError(err.message);
                setSubmitting(false);
              });
          }}
          disabled={searchIcon}
        >
          {props.currRm ? 'Update' : 'Assign'}
        </button>
      </div>
      {error ? (
        <div className="w-full font-roboto font-normal text-red-300 text-base py-4">
          <p>{error}</p>
        </div>
      ) : null}
    </div>
  );
}

export default AssignRmModalField;
